import graphql from "babel-plugin-relay/macro";

export const SearchResultsQuery = graphql`
  query SearchResultsQuery(
    $after: String
    $first: Int
    $q: String
    $titleOnly: Boolean
    $authors: [Int]
    $categories: [Int]
    $references: [Int]
    $sort: String
  ) {
    search(
      after: $after
      first: $first
      q: $q
      titleOnly: $titleOnly
      authors: $authors
      categories: $categories
      references: $references
      sort: $sort
    ) {
      totalCount
      edges {
        node {
          id
          pk
          name
          preview
          hasAttachments
          bloc {
            name
          }
          isHomeBloc
          category {
            name
          }
          effectiveDate
          legacyEffectiveDate
          revisionDate
          approvalDate
          restricted
        }
      }
    }
  }
`;

export default SearchResultsQuery;
